const gardenFeaturesJa = {
  // ヘッジトリマー（ht-001〜ht-010）
  product_ht_001_feature_1_title: '强力な切断パフォーマンス',
  product_ht_001_feature_1_desc: '高効率ブラシレスモーターを搭載し、チェンスピードは最大8m/sに達します。硬木や木材を素早く、かつ滑らかに切断可能です。',
  product_ht_001_feature_2_title: '軽量・コンパクト設計',
  product_ht_001_feature_2_desc: 'わずか1.32kgの軽量設計。人間工学に基づいたハンドル形状により、バランスが良く、狭い場所や高所でも片手で正確に操作できます。',
  product_ht_001_feature_3_title: '工具レス調整と注油',
  product_ht_001_feature_3_desc: '工具なしでチェンの張り調整が可能なクイックアクセス機構を採用。効率的な注油システムにより、チェンの寿命を大幅に延ばします。',
  product_ht_001_feature_4_title: '多重安全保護機能',
  product_ht_001_feature_4_desc: 'ハンドガードとセーフティロックを標準装備。誤作動を防ぎ、過酷な現場でも作業者の安全をしっかり守ります。',
  product_ht_001_feature_5_title: '20V 2.0Ahコードレス自由',
  product_ht_001_feature_5_desc: '20V 2.0Ahバッテリーでコードレス動作を提供し、延長コードの制限なく庭のどこでも刈り込めます。',

  product_ht_002_feature_1_title: '切断能力の向上',
  product_ht_002_feature_1_desc: 'ガイドバー長を160mmにアップグレード。8m/sの強力なチェンスピードとの組み合わせにより、より太い枝や木材に対応し、作業効率を大幅に向上させます。',
  product_ht_002_feature_2_title: '優れたパワーウェイトレシオ',
  product_ht_002_feature_2_desc: 'わずか1.43kgの軽量ボディに工業グレードのパワーを凝縮。長時間の作業でも疲れにくく、高い切断力を発揮します。',
  product_ht_002_feature_3_title: '精密な操作性とバランス',
  product_ht_002_feature_3_desc: '最適化された重心バランス設計により、あらゆる角度からの切断でも安定した操作が可能。果樹園の剪定や複雑な造園作業に最適です。',
  product_ht_002_feature_4_title: 'クイックメンテナンス',
  product_ht_002_feature_4_desc: '工具レスのチェーン張り調整機能を搭載し、現場での素早い調整が可能。堅牢な32リンクチェン構造により、高負荷時でも優れた耐久性を維持します。',
  product_ht_002_feature_5_title: '60分バッテリー充電',
  product_ht_002_feature_5_desc: '20V 2.0Ahバッテリーを60分で充電し、1時間以内にフルの生け垣刈り込みパワーを回復します。',

  product_ht_003_feature_1_title: '工業級の切断パフォーマンス',
  product_ht_003_feature_1_desc: '10m/sのチェンスピードと230mmプロ用ガイドバーを搭載。中・大型木材の切断も余裕でこなし、エンジン式に匹敵するパワフルな切断体験を提供します。',
  product_ht_003_feature_2_title: '全自動給油システム',
  product_ht_003_feature_2_desc: '270mlの大容量オイルタンクと自動給油ポンプを装備。長時間の作業でもチェンを常に最適な潤滑状態に保ち、摩耗を抑えて連続作業をサポートします。',
  product_ht_003_feature_3_title: '優れたエルゴノミクス制御',
  product_ht_003_feature_3_desc: '人間工学に基づいた両手ハンドル設計。フロントハンドガードがバランスと安全性を両立し、高負荷な切断作業でも抜群の安定感と精度を実現します。',
  product_ht_003_feature_4_title: '持久续航与耐用性',
  product_ht_003_feature_4_desc: '過酷な現場作業向けに開発。最適化された出力システムによりバッテリー効率を最大化し、堅牢なボディ構造でどんな厳しい環境下でも信頼性を発挥します。',
  product_ht_003_feature_5_title: '2800mm伸縮ボディ',
  product_ht_003_feature_5_desc: '総リーチ2800mmで脚立なしに地面から高い生け垣の頂部を刈り込め、より安全で速いです。',

  product_ht_004_feature_1_title: '高トルクブラシレスモーター',
  product_ht_004_feature_1_desc: '高度なブラシレス技術を採用し、8m/sの安定したチェンスピードを実現。高効率な電力変換により、連続した切断作業でも強力なトルクを維持します。',
  product_ht_004_feature_2_title: '190mmの拡張切断能力',
  product_ht_004_feature_2_desc: '標準的な片手鋸に比べ、190mmのロングガイドバーがより広い切断範囲を提供。太い枝や木材も余裕でこなし、柔軟な作業が可能です。',
  product_ht_004_feature_3_title: 'インテリジェント自動給油',
  product_ht_004_feature_3_desc: '60mlのオイルタンクと自動給油ポンプを搭載。作業中にチェンへ自動で給油し、摩擦熱を大幅に低減。手動給油の手間を省き、コンポーネントの寿命を延ばします。',
  product_ht_004_feature_4_title: '完璧なエルゴノミクスバランス',
  product_ht_004_feature_4_desc: '1.7kgの最適化された重量配分。視覚的な重心と握り心地を両立し、片手操作でも正確なカットが可能。長時間の使用による腕の疲労を大幅に軽減します。',
  product_ht_004_feature_5_title: '工具レスのクイック調整',
  product_ht_004_feature_5_desc: '工具レスの張り調整構造により、現場で数秒でチェン調整が可能。透明なオイル窓により残量を一目で確認でき、メンテナンスが効率的に行えます。',

  product_ht_005_feature_1_title: '520mm回転ヘッドトリマー',
  product_ht_005_feature_1_desc: '回転ヘッドで体を動かさずに生け垣の側面と頂部を刈り込め、高い境界生け垣に最適です。',
  product_ht_005_feature_2_title: '≦25mm可動ヘッド切断',
  product_ht_005_feature_2_desc: 'すべてのヘッド角度で≦25mmの枝に対応し、すべての刈り込み位置で切断能力を維持します。',
  product_ht_005_feature_3_title: 'マルチポジションヘッドロック',
  product_ht_005_feature_3_desc: 'ヘッドが複数の角度で確実にロックし、調整停止なしに垂直面、平らな頂部、斜め輪郭の刈り込みに対応します。',
  product_ht_005_feature_4_title: '2.6kg回転ヘッドバランス',
  product_ht_005_feature_4_desc: '2.6kgのバランスの取れた回転ヘッド設計で異なる角度に延伸してもツールが快適なままです。',
  product_ht_005_feature_5_title: '20Vコードレス、2.0Ahバッテリー',
  product_ht_005_feature_5_desc: '20V 2.0Ahコードレスの自由で生け垣の周りでの継続的な回転と位置変更が延長コードのドラッグなしに可能です。',

  product_ht_006_feature_1_title: '520mmレーザーカット精密ブレード',
  product_ht_006_feature_1_desc: 'レーザーカットブレード歯で例外的にクリーンな生け垣カットを提供し、植物の速い再成長と健康的な外観を促します。',
  product_ht_006_feature_2_title: '≦22mm精密切断能力',
  product_ht_006_feature_2_desc: '≦22mmの正式な生け垣の精密トリミング向けに設計され、カット品質が庭の美学を直接反映します。',
  product_ht_006_feature_3_title: '1300SPM品質カット周波数',
  product_ht_006_feature_3_desc: 'レーザーカット歯との1300SPMの組み合わせでシリーズ最高の生け垣表面仕上げを提供します。',
  product_ht_006_feature_4_title: '2.8kgプロトリミング重量',
  product_ht_006_feature_4_desc: '2.8kgの重量で正式な庭の生け垣の完璧な直線水平トリムに必要な安定性を提供します。',
  product_ht_006_feature_5_title: 'CE/GS/EMC認証安全',
  product_ht_006_feature_5_desc: 'CE、GS、EMC認証を取得し、住宅・プロ庭園環境での安全でコンプライアントな動作を実現します。',

  product_ht_007_feature_1_title: '500mm超軽量ガーデントリマー',
  product_ht_007_feature_1_desc: '2.4kgで最軽量のヘッジトリマー、小型庭園や快適さを優先するユーザーに最適です。',
  product_ht_007_feature_2_title: '≦25mm軽量切断パワー',
  product_ht_007_feature_2_desc: '最軽量でも≦25mmの枝に対応し、多用途な庭の生け垣メンテナンスが可能です。',
  product_ht_007_feature_3_title: '1350SPM軽量ボディ速度',
  product_ht_007_feature_3_desc: '最軽量本体での1350SPMでコンパクトな住宅の生け垣での疲労を最小限に抑えながら速くクリーンなカットを実現します。',
  product_ht_007_feature_4_title: '2.4kg最小疲労設計',
  product_ht_007_feature_4_desc: '2.4kgはヘッジトリマーシリーズ最軽量で、長時間の快適さを重視するユーザーのために設計されています。',
  product_ht_007_feature_5_title: '79dB静音近隣友好',
  product_ht_007_feature_5_desc: '≦79dBはシリーズで最も静かなヘッジトリマー、騒音に敏感な住宅街に最適です。',

  product_ht_008_feature_1_title: '450mmコンパクトガーデントリマー',
  product_ht_008_feature_1_desc: '450mmの最小ブレードで小型装飾生け垣、トピアリーボール、整形庭園低木の精密作業に対応します。',
  product_ht_008_feature_2_title: '≦20mm繊細装飾カット',
  product_ht_008_feature_2_desc: '≦20mmは頻繁な精密整形が必要な装飾生け垣の柔らかな新しい成長に対応します。',
  product_ht_008_feature_3_title: 'わずか2.2kgコンパクト重量',
  product_ht_008_feature_3_desc: 'わずか2.2kgで最小・最軽量のトリマー、装飾トピアリーの近接ディテール作業に最適です。',
  product_ht_008_feature_4_title: '78dBウィスパー静音動作',
  product_ht_008_feature_4_desc: '≦78dBはヘッジトリマーラインアップで最低評価、早朝の庭作業に最適です。',
  product_ht_008_feature_5_title: 'コンパクト698mm全長',
  product_ht_008_feature_5_desc: '698mmの短い全長でこのトリマーを精密な装飾作業で最も機動性の高いツールにします。',

  product_ht_009_feature_1_title: '550mm重型ヘッジブレード',
  product_ht_009_feature_1_desc: '550mmブレードで大型の過成長生け垣や標準長トリマーでは困難な太い新成長に対応します。',
  product_ht_009_feature_2_title: '≦30mm最大枝切断能力',
  product_ht_009_feature_2_desc: '30mmの切断能力はヘッジトリマーシリーズ最大で、太い枝を持つ大型確立済み生け垣に対応します。',
  product_ht_009_feature_3_title: '4.0Ah延長ランタイムバッテリー',
  product_ht_009_feature_3_desc: '20V 4.0Ahで大型庭園や商業生け垣メンテナンス契約に必要な延長ランタイムを提供します。',
  product_ht_009_feature_4_title: '2.8kg強力重型本体',
  product_ht_009_feature_4_desc: '2.8kg本体で最も要求の厳しい太い枝の生け垣刈り込みに必要な質量と安定性を提供します。',
  product_ht_009_feature_5_title: '1200SPM重型成長速度',
  product_ht_009_feature_5_desc: '1200SPMは≦30mmの枝への最大切断力向けに調整され、軟嫩成長の速度よりもパワーを優先します。',

  product_ht_010_feature_1_title: '520mmプロガーデンブレード',
  product_ht_010_feature_1_desc: '硬化歯を持つプロスペック520mmブレードで様々な生け垣種類の頻繁な商業使用に対応します。',
  product_ht_010_feature_2_title: '≦25mmプロ切断能力',
  product_ht_010_feature_2_desc: 'ガマズミ、ホーンビーム、イチイなど一般的な商業生け垣種類すべてで≦25mmの枝に対応します。',
  product_ht_010_feature_3_title: '24ヶ月商業保証',
  product_ht_010_feature_3_desc: '2年保証でこのトリマーを毎日複数の物件で使用するプロガーデン業者をサポートします。',
  product_ht_010_feature_4_title: '1350SPM商業速度',
  product_ht_010_feature_4_desc: '1350SPMの持続した商業グレードの切断速度で大型クライアント物件の終日生け垣メンテナンスに対応します。',
  product_ht_010_feature_5_title: '長寿命用硬化ブレード鋼',
  product_ht_010_feature_5_desc: '硬化ブレード鋼で標準の庭のトリマーブレードよりも重度の商業使用下での鋭さを長く保ちます。',

  // ポールプルーナー（pp-001〜pp-010）
  product_pp_001_feature_1_title: '優れた到達範囲',
  product_pp_001_feature_1_desc: '全長297cmに58cmの伸縮延長ポールを組み合わせることで、脚立なしで高所の生垣剪定が可能。作業の安全性と利便性が大幅に向上します。',
  product_pp_001_feature_2_title: '11段階の角度調整ヘッド',
  product_pp_001_feature_2_desc: 'ヘッド部は-60°から+90°まで11段階の角度調整が可能。側面の垂直カットから頂面の水平カットまで、あらゆるシーンで最適な角度を選べます。',
  product_pp_001_feature_3_title: '高速プロフェッショナルカット',
  product_pp_001_feature_3_desc: '2300 spmの高回転スピードと410mmのブレード、15mmの刃間隔を採用。植物を傷めることなく、素早く精密に枝を刈り込みます。',
  product_pp_001_feature_4_title: '軽量・バランス設計',
  product_pp_001_feature_4_desc: '軽量なアルミ製ポールを採用し、重心バランスを最適化。付属のストラップを使用することで、長時間の高所作業による肩や腕への負担を軽減します。',
  product_pp_001_feature_5_title: '工業用グレードの耐久ブレード',
  product_pp_001_feature_5_desc: '49cmのブレードには高強度合金を採用。プロの造園作業向けに設計されており、耐摩耗性に優れ、過酷な環境下でも鋭い切れ味が持続します。',
  
  product_pp_002_feature_1_title: '32mmの強力な切断能力',
  product_pp_002_feature_1_desc: '最大32mmの切断径を実現。工業用グレードの超硬ブレードにより、高所の乾燥した枝や硬い太枝も一度でスムーズに切り落とせます。',
  product_pp_002_feature_2_title: '5段階の角度調整ヘッド',
  product_pp_002_feature_2_desc: 'ヘッド部は-76°から+76°まで5段階の角度調整が可能。入り組んだ枝を巧みに避け、密集した樹冠の中でも最適な角度でカットできます。',
  product_pp_002_feature_3_title: '安全な高所伸長パフォーマンス',
  product_pp_002_feature_3_desc: '全長258cmに58cmの伸縮延長機能を搭載。不安定な脚立作業から解放され、地上から安全に高所の枝打ち作業を完遂できます。',
  product_pp_002_feature_4_title: '軽量かつ高耐久な構造',
  product_pp_002_feature_4_desc: '高強度アルミ合金を採用し、剛性と軽量化を両立。ストラップ設計により、高所作業時の手や肩への負担を大幅に軽減し、長時間の作業をサポートします。',
  product_pp_002_feature_5_title: '自动链条润滑',
  product_pp_002_feature_5_desc: '自动给油器即使在最大 3200 mm 触达时也保持链条正确润滑，减少链条磨损。',
  
  product_pp_003_feature_1_title: '高所伐採の強力なパフォーマンス',
  product_pp_003_feature_1_desc: '200mmの有効切断長と5m/sの安定したチェンスピードを実現。高所の太い枝の伐採に特化し、手動工具を遥かに凌ぐ効率で重作業を完遂します。',
  product_pp_003_feature_2_title: '2段階調整式ロングポールシステム',
  product_pp_003_feature_2_desc: '作業長を2120mmと2700mmの2段階で切り替え可能。用途に合わせて柔軟に対応でき、地上から高所の樹木を正確にメンテナンスできます。',
  product_pp_003_feature_3_title: '統合型自動給油システム',
  product_pp_003_feature_3_desc: '80mlのオイルタンクを内蔵し、作業中に自動で給油。摩擦熱と摩耗を抑え、2.7m先の先端部でも常に鋭い切れ味とスムーズな操作を維持します。',
  product_pp_003_feature_4_title: '強化型ダブルハンドル設計',
  product_pp_003_feature_4_desc: '補助D型ハンドルとリアグリップを採用。ポールの伸長時でも安定した操作が可能で、硬い木材に対してもブレのない精密な切断を実現します。',
  product_pp_003_feature_5_title: '工業用レベルの全天候型耐久性',
  product_pp_003_feature_5_desc: '堅牢で衝撃に強い構造を採用。3.25kgの最適化された重量とプロ仕様のストラップにより、過酷な現場環境でも長寿命かつ高強度な作業を保証します。',


  product_pp_004_feature_1_title: '轻量化与平衡系统',
  product_pp_004_feature_1_desc: '采用轻量化铝合金长杆设计，优化了重心分布。配合背带使用，可有效减轻长时间高空作业带来的肩部与手臂负担。',
  product_pp_004_feature_2_title: '≤80 mm 轻量高触达',
  product_pp_004_feature_2_desc: '轻量设计配合 ≤80 mm 切割能力，长触达修剪不牺牲切割动力。',
  product_pp_004_feature_3_title: '3.5 m/s 轻量速度',
  product_pp_004_feature_3_desc: '最轻机身中提供 3.5 m/s，快速切割与轻松操控结合，减少用户疲劳。',
  product_pp_004_feature_4_title: '20V 电池轻量组合',
  product_pp_004_feature_4_desc: '20V 2.0Ah 电池保持最轻修剪机的轻量，树木间移动无需拖拉电源线。',
  product_pp_004_feature_5_title: '低反弹链条设计',
  product_pp_004_feature_5_desc: '低反弹链条降低切割时导板突然运动的风险，对安全头顶修剪很重要。',


  product_pp_005_feature_1_title: '工业级耐用刀片',
  product_pp_005_feature_1_desc: '49cm 的可见刀片采用高强度合金材质，专为高强度园林维护打造。出色的抗磨损性能，确保在各种气候条件下依然保持锋利持久。',
  product_pp_005_feature_2_title: '≤100 mm 最大枝条切割',
  product_pp_005_feature_2_desc: '100 mm 切割能力应对无需专业树艺师设备的最大住宅树木修剪任务。',
  product_pp_005_feature_3_title: '4.0 m/s 最高链条速度',
  product_pp_005_feature_3_desc: '4.0 m/s 是可用的最高链条速度，能够快速清除浓密树冠大型树木的枝条。',
  product_pp_005_feature_4_title: '20V 4.0Ah 重型修剪续航',
  product_pp_005_feature_4_desc: '4.0Ah 电池支持 250 mm 导板和 100 mm 切割能力的较高功耗，续航更长。',
  product_pp_005_feature_5_title: '4.0Ah 延长续航',
  product_pp_005_feature_5_desc: '4.0Ah 电池提供专门针对 250 mm 重型导板较高能耗需求选择的延长续航。',


  // 芝生ケア（lc-001〜lc-010）
  product_lc_001_feature_1_title: '高速精密研磨パフォーマンス',
  product_lc_001_feature_1_desc: '5000/minの高速回転スピードを実現。プロ仕様の砥石により、損傷した刃を素早く修復し、鈍くなったチェンを新品のような切れ味に蘇らせます。',
  product_lc_001_feature_2_title: '全方位多角度調整システム',
  product_lc_001_feature_2_desc: '左右-35°から+35°までの幅広い角度調整が可能。精密な角度目盛により、あらゆるブランドや規格のチェンに対し、すべてのコマを一貫した精度で研磨できます。',
  product_lc_001_feature_3_title: 'LED作業灯を標準装備',
  product_lc_001_feature_3_desc: '高輝度LEDワークライトを内蔵。暗い作業場やガレージでも研磨ポイントをはっきりと確認でき、極めて高い精度と安全性を確保します。',
  product_lc_001_feature_4_title: 'ンテリジェント再起動防止機能',
  product_lc_001_feature_4_desc: '再起動防止機能を搭載し、停電復旧時の不意な作動を防ぎます。防振ベース設計により、高速回転時でも揺るぎない安定した操作感を提供します。',
  product_lc_001_feature_5_title: 'コンパクトで堅牢な工業設計',
  product_lc_001_feature_5_desc: '1.9kgのコンパクトなボディに人間工学に基づいたハンドルを採用。ワークベンチへの固定も現場への持ち運びも容易で、チェンソーを長く愛用するための必須メンテナンスツールです。',

  product_lc_002_feature_1_title: '最高峰の研磨効率',
  product_lc_002_feature_1_desc: '6500/minの超高速回転を実現。研磨効率が大幅に向上し、ひどく摩耗したチェンでも短時間でプロ級の鋭さを取り戻すことができます。',
  product_lc_002_feature_2_title: '超軽量・ポータブル設計',
  product_lc_002_feature_2_desc: 'わずか1.65kgの軽量設計。クラス最軽量のプロモデルであり、人間工学に基づいたグリップと相まって、作業場から現場への持ち運びや操作の柔軟性が向上します。',
  product_lc_002_feature_3_title: '高精度LED照明システム',
  product_lc_002_feature_3_desc: '強力なLEDワークライトを標準装備。影を排除し、暗所や複雑な環境下でもすべてのチェンコマを正確に合わせることができ、「誤差ゼロ」の研磨を実現します。',
  product_lc_002_feature_4_title: '汎用性の高い左右35°調整',
  product_lc_002_feature_4_desc: '左右35°の精密な角度調整が可能。市販の主要なチェン規格すべてに適合し、これ一台で手持ちの全チェンのメンテナンスに対応できます。',
  product_lc_002_feature_5_title: '高度な安全・再起動防止機能',
  product_lc_002_feature_5_desc: '再起動防止機能を搭載し、停電後の不意な作動を完全にガード。堅牢なガードと防滑ベースにより、ハードな作業でも工業レベルの安全を確保します。',

  product_lc_003_feature_1_title: '350mm長刃芝シアー',
  product_lc_003_feature_1_desc: '350mmブレードで芝刈り機が届かない壁、フェンス、舗装のエッジに沿って草を切ります。',
  product_lc_003_feature_2_title: '≦20mm精密シアー能力',
  product_lc_003_feature_2_desc: '≦20mmの草成長に最適化され、壁ベースやボーダー周りの障害物周りの芝エッジのクリーンで精密なシアリングを実現します。',
  product_lc_003_feature_3_title: '1350SPMシアーストローク速度',
  product_lc_003_feature_3_desc: '1350SPMの往復ブレードで壁や舗装エッジに沿ったクリーンなはさみのような草カットを実現します。',
  product_lc_003_feature_4_title: '2.6kg制御シアー重量',
  product_lc_003_feature_4_desc: '2.6kgの重量で壁ベースとボーダーに沿った直線シアリングのための十分な安定性を提供します。',
  product_lc_003_feature_5_title: '78dB静音庭シアリング',
  product_lc_003_feature_5_desc: '静音≦78dBで芝エッジシアリングが最も静かな住宅街でも許容されます。',

  product_lc_004_feature_1_title: '高速240km/hリーフブロワー',
  product_lc_004_feature_1_desc: '最大240km/hの風速で小道、車道、パティオから葉、草の刈り屑、デブリを素早く取り除きます。',
  product_lc_004_feature_2_title: '20Vコードレスブロー自由',
  product_lc_004_feature_2_desc: '20Vコードレス動作でエアホースや電源コードの管理なく庭全体を自由に移動できます。',
  product_lc_004_feature_3_title: '1.2kg超軽量ブロワー',
  product_lc_004_feature_3_desc: 'わずか1.2kgでこのブロワーは素早い小道清掃とデブリ除去作業に片手で使用できます。',
  product_lc_004_feature_4_title: '72dB静音ブロー動作',
  product_lc_004_feature_4_desc: '≦72dBでシリーズで最も静かな庭用ブロワー、早朝の小道清掃に適しています。',
  product_lc_004_feature_5_title: '可変速トリガーコントロール',
  product_lc_004_feature_5_desc: '可変トリガーで穏やかなデブリ散乱から濡れた葉の除去の最大パワーまでの風速コントロールを可能にします。',

  product_lc_005_feature_1_title: '300mmスカリファイヤードラム',
  product_lc_005_feature_1_desc: '300mmのスカリファイヤードラムで芝生からコケ、サッチ、枯れ草を除去し、栄養と水分の吸収を改善します。',
  product_lc_005_feature_2_title: '≦50mmスカリファイング深さ',
  product_lc_005_feature_2_desc: '50mmの作業深さがサッチ層に浸透し、芝生から圧縮された有機物を取り出します。',
  product_lc_005_feature_3_title: '1800RPMサッチ除去速度',
  product_lc_005_feature_3_desc: '1800RPMのドラム速度で根系を傷つけずにすべての草の種類の圧縮サッチを効率的に除去します。',
  product_lc_005_feature_4_title: '2.8kgスカリファイヤーバランス',
  product_lc_005_feature_4_desc: '2.8kgのバランスされた重量で全刈り幅にわたって均一なサッチ除去のための一定のドラムから芝生への接触を提供します。',
  product_lc_005_feature_5_title: '20V 2.0Ahコードレススカリファイング',
  product_lc_005_feature_5_desc: '20Vコードレス動作で庭全体に電源ケーブルを管理することなく完全な芝スカリファイングが可能です。',

  product_lc_006_feature_1_title: '200mmエアレータースパイクドラム',
  product_lc_006_feature_1_desc: '200mmのエアレータードラムで圧縮された芝土に通気穴を作り、根の成長と排水を改善します。',
  product_lc_006_feature_2_title: '≦80mm土壌侵入深さ',
  product_lc_006_feature_2_desc: '80mmのスパイク深さが圧縮土層の深部に届き、芝の健康を改善する効果的な通気を実現します。',
  product_lc_006_feature_3_title: '3500RPM通気速度',
  product_lc_006_feature_3_desc: '3500RPMのエアレータースパイク速度で効率的な芝通気カバレッジのための圧縮地面を素早く貫通します。',
  product_lc_006_feature_4_title: '20Vコードレス土壌通気',
  product_lc_006_feature_4_desc: '20Vコードレスエアレーターで電源コードの制限なく完全な春の処理のための完全な芝カバレッジを提供します。',
  product_lc_006_feature_5_title: '3.2kg安定エアレーター本体',
  product_lc_006_feature_5_desc: '3.2kgの本体重量で通気スパイクが硬い圧縮地面への下向きの力を維持します。',

  product_lc_007_feature_1_title: '280mmヘッジ・ボーダートリマー',
  product_lc_007_feature_1_desc: '280mmの往復ブレードが1本の多用途ツールで芝エッジと低いボーダー生け垣刈り込みの両方を処理します。',
  product_lc_007_feature_2_title: '≦60mm深いボーダー切断',
  product_lc_007_feature_2_desc: '60mmの切断深さで庭のボーダーに沿った大量のボーダー草と過成長のエッジ成長を処理します。',
  product_lc_007_feature_3_title: '1800RPM多用途トリミング',
  product_lc_007_feature_3_desc: '1800RPMで繊細な芝エッジと重いボーダー成長の両方に適した柔軟な切断速度を提供します。',
  product_lc_007_feature_4_title: '3.5kgプロボーダーツール',
  product_lc_007_feature_4_desc: '3.5kgのプロウェイトで過成長のボーダー草や茨のエッジを切断する際の安定性を提供します。',
  product_lc_007_feature_5_title: '長セッション用4.0Ahバッテリー',
  product_lc_007_feature_5_desc: '4.0Ahバッテリーで大型物件のボーダーと芝エッジメンテナンスのための延長ランタイムを提供します。',

  product_lc_008_feature_1_title: '300mmプロ芝刈りブレード',
  product_lc_008_feature_1_desc: 'プロ300mmブレードで商業芝生ケア向けに大型芝生と厚い草成長を処理します。',
  product_lc_008_feature_2_title: '≦50mm高草切断',
  product_lc_008_feature_2_desc: '50mmの切断高さ能力で予め切断せずに過成長芝生と中程度の粗草を処理します。',
  product_lc_008_feature_3_title: '1500RPM重型草速度',
  product_lc_008_feature_3_desc: '1500RPMで緻密な厚い草成長を通じて一定の結果で切断するための十分なトルクを提供します。',
  product_lc_008_feature_4_title: '3.8kgプログレード構造',
  product_lc_008_feature_4_desc: '3.8kgのプロ本体で定期的な集中メンテナンスが必要な芝生での繰り返しの商業使用向けに製造されています。',
  product_lc_008_feature_5_title: '4.0Ah商業ランタイムバッテリー',
  product_lc_008_feature_5_desc: '4.0Ahでプロ芝メンテナンス業者が複数物件の一日に必要な延長ランタイムを提供します。',

  product_lc_009_feature_1_title: '12Lガーデンスプレータンク',
  product_lc_009_feature_1_desc: '12リットルのタンク容量で大型庭エリアでの芝施肥、除草剤処理、害虫駆除を処理します。',
  product_lc_009_feature_2_title: '1200RPMバッテリーポンプ速度',
  product_lc_009_feature_2_desc: 'バッテリー駆動の1200RPMポンプで手動ポンプの疲労なく一定のスプレー圧力を提供します。',
  product_lc_009_feature_3_title: '4.2kgロードスプレーバランス',
  product_lc_009_feature_3_desc: '4.2kgのフルロード重量はスプレー処理中に大型庭エリアを運ぶのに管理可能です。',
  product_lc_009_feature_4_title: '68dB超静音スプレー',
  product_lc_009_feature_4_desc: '≦68dBは庭シリーズで最も静かなツールで早朝や夕方のスプレー施用に十分な静音性です。',
  product_lc_009_feature_5_title: '20V 4.0Ah延長スプレーランタイム',
  product_lc_009_feature_5_desc: '4.0Ahバッテリーで大型芝生と広い庭エリアを処理するための延長スプレーセッションを提供します。',

  product_lc_010_feature_1_title: '300mmマルチングモーブレード',
  product_lc_010_feature_1_desc: '300mmのマルチングブレードで草の刈り屑を細かく刻み、天然肥料として芝生に戻します。',
  product_lc_010_feature_2_title: '≦30mm正確なマルチング高さ',
  product_lc_010_feature_2_desc: '≦30mmの高さで刈り込みとマルチングを行い、草屑を素早く分解して芝を養う細かい粒子にリサイクルします。',
  product_lc_010_feature_3_title: '2800RPMマルチング速度',
  product_lc_010_feature_3_desc: '2800RPMで芝の表面に消えていく細かい草マルチ粒子を作り、刈り屑の収集が不要です。',
  product_lc_010_feature_4_title: '3.0kgマルチング芝刈り機重量',
  product_lc_010_feature_4_desc: '3.0kgでこのマルチング芝刈り機は追加のマルチング機構を処理しながら快適に操縦できます。',
  product_lc_010_feature_5_title: '20V 2.0Ahエコ芝刈り',
  product_lc_010_feature_5_desc: 'ゼロエミッション20Vバッテリー芝刈りで芝に栄養を戻し、袋詰めと廃棄の環境に優しい代替手段です。',

  // ===== ガーデンツールアクセサリー翻訳 (ht / pp / lc シリーズ) =====附件说明

  // ヘッジトリマーシリーズ配件（ht-001〜ht-010、全製品で同じキーを共有）
  // ht_accessory_1_name: '20Vリチウムバッテリー',
  // ht_accessory_1_desc: '大容量20Vリチウムバッテリー、長時間の生け垣刈り込みに対応する持続的な電力を供給',
  // ht_accessory_2_name: '急速充電器',
  // ht_accessory_2_desc: 'LED充電インジケーター付き60分急速充電器、素早いパワー回復を実現',
  // ht_accessory_3_name: '専用交換部品',
  // ht_accessory_3_desc: '純正交換部品で工具を常に最高の性能に維持',
  // ht_accessory_4_name: '補完アクセサリー',
  // ht_accessory_4_desc: '工具の使用シーンと性能を拡張する機能的な補完アクセサリー',
  // ht_accessory_5_name: '耐切創安全グローブ',
  // ht_accessory_5_desc: 'プロ仕様の防切創グローブ、作業中のブレード接触から手を保護',
  // ht_accessory_6_name: '安全保護部品',
  // ht_accessory_6_desc: '保管・使用時の工具の安全を確保する保護安全部品',
  // ht_accessory_7_name: 'メンテナンスキット',
  // ht_accessory_7_desc: 'クリーニングブラシ・潤滑剤・ふきんを含むプロ仕様メンテナンスキット、工具寿命を延長',
  // ht_accessory_8_name: 'ポータブル収納バッグ',
  // ht_accessory_8_desc: 'パッド入り収納バッグ、ヘッジトリマーの安全な持ち運びと保管に最適',

  // ポールプルーナーシリーズアクセサリー（pp-001〜pp-010）
  pp_accessory_1_name: '20Vリチウムバッテリー',
  pp_accessory_1_desc: '防水防塵20V大容量リチウムバッテリー、長時間の高枝剪定に安定した電力を供給',
  pp_accessory_2_name: '急速充電器',
  pp_accessory_2_desc: 'LEDステータスインジケーター付きスマート急速充電器、60分で満充電',
  pp_accessory_3_name: 'ガイドバー＆チェーンセット',
  pp_accessory_3_desc: '高品質の交換用ガイドバーとチェーンセット、最高の切断性能を維持',
  pp_accessory_4_name: 'チェーン研磨ヤスリキット',
  pp_accessory_4_desc: 'プロ仕様チェーン研磨ヤスリキット、チェーンの鋭さを維持し寿命を延長',
  pp_accessory_5_name: 'バー＆チェーンオイル',
  pp_accessory_5_desc: '生分解性バー＆チェーン潤滑オイル、チェーンの摩耗を軽減しガイドバーを保護',
  pp_accessory_6_name: 'ショルダーハーネスストラップ',
  pp_accessory_6_desc: '調整可能なパッド入りショルダーハーネス、長時間の頭上作業時の腕疲労を大幅に軽減',
  pp_accessory_7_name: '防護グローブ',
  pp_accessory_7_desc: 'プロ仕様の防切創安全グローブ、チェーンソーの危険から操作者を保護',
  pp_accessory_8_name: 'ロング収納バッグ',
  pp_accessory_8_desc: 'ポールプルーナー専用の長型収納バッグ、複数ポケット付きで持ち運びが便利',

  // 芝生ケアシリーズアクセサリー（lc-001〜lc-010）
  lc_accessory_1_name: '20Vリチウムバッテリー',
  lc_accessory_1_desc: '防水防塵20Vリチウムバッテリー、各種芝生ケアツールに持続的な安定電力を供給',
  lc_accessory_2_name: '急速充電器',
  lc_accessory_2_desc: 'デュアルLEDインジケーター付き急速充電器、60分で満充電、効率的な作業をサポート',
  lc_accessory_3_name: '交換用切断部品',
  lc_accessory_3_desc: '純正交換用切断部品、工具が最高の切断結果を発揮し続けることを保証',
  lc_accessory_4_name: '機能的アクセサリー',
  lc_accessory_4_desc: '工具の柔軟性と効率を高める専用機能的アクセサリー',
  lc_accessory_5_name: '専用消耗品',
  lc_accessory_5_desc: '工具と完全互換の高品質専用消耗品、継続的な効率作業を確保',
  lc_accessory_6_name: '保護安全装備',
  lc_accessory_6_desc: '作業中の操作者を総合的に保護するプロ仕様の保護安全装備',
  lc_accessory_7_name: 'メンテナンスツールキット',
  lc_accessory_7_desc: 'クリーニング・メンテナンス・修理に必要なすべてを網羅する完全なメンテナンスキット',
  lc_accessory_8_name: '安全保護セット',
  lc_accessory_8_desc: 'ゴーグルとグローブを含む総合安全保護セット、安全な作業を確保',
};

export default gardenFeaturesJa;
